import React from 'react';
import './LoadingSpinner.css';

const LoadingSpinner = ({ size = 40 }) => (
  <div className="spinner-container">
    <div className="spinner" style={{ width: size, height: size }}></div>
  </div>
);

export default LoadingSpinner;
